const siteConfig = {
  brandName: "mendoriah",
  wordmark: "mendoriah",
  orderPrefix: "MND",
  website: "https://mendoriah.xyz",
  tagline: "Designed to move with you.",
  description:
    "Considered mobile stands, cases, wallets and workspace accessories designed for flexible everyday routines.",
  contact: {
    email: "cycle@mendoriah.xyz",
    supportEmail: "cycle@mendoriah.xyz",
    privacyEmail: "cycle@mendoriah.xyz",
    address: "522 W Riverside Ave, Suite 4436, Spokane, WA 99201",
    hours: "Response within 24 hours",
  },
  currency: {
    code: "USD",
    symbol: "$",
    decimalDigits: 2,
  },
  locale: "en-US",
  shipping: {
    standardRate: 9.99,
    standardEstimate: "3–5 business days",
    expressEstimate: "1–2 business days",
    returnsWindowDays: 30,
  },
  paymentMethods: ["Visa", "Mastercard", "American Express", "JCB", "UnionPay"],
  social: [],
  navigation: [
    {
      id: "shop",
      label: "Shop All",
      path: "/shop",
    },
    {
      id: "phones",
      label: "Phones",
      path: "/shop?category=Phones",
    },
    {
      id: "tablets",
      label: "Tablets",
      path: "/shop?category=Tablets",
    },
    {
      id: "laptops",
      label: "Laptops",
      path: "/shop?category=Laptops",
    },
    {
      id: "workspace",
      label: "Workspace",
      path: "/shop?category=Workspace",
    },
    {
      id: "carry",
      label: "Carry",
      path: "/shop?category=Carry",
    },
    {
      id: "about",
      label: "Our Story",
      path: "/about",
    },
  ],
};

export default siteConfig;
